import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  SIGN_IN,
  ADMIN_DASHBOARD,
  REFERRER_DASHBOARD,
} from '@/lib/constants/routes';
import { GlobalRole } from '@/lib/auth/models';
import { isAdminOrSystemRole } from '@/lib/auth/roles';
import { queryClient } from '@/api/common/client';
import { ensureAuthData } from '@/api/auth/auth-query';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const data = await ensureAuthData(queryClient);
    if (!data.authenticated || !data.user) {
      throw redirect({ to: SIGN_IN });
    }

    const role = data.user.globalRole;

    if (isAdminOrSystemRole(role)) {
      throw redirect({ to: ADMIN_DASHBOARD });
    } else if (role === GlobalRole.REFERRER) {
      throw redirect({ to: REFERRER_DASHBOARD });
    }

    throw redirect({ to: SIGN_IN });
  },
  component: () => null,
});
